import { render } from "./SupplierFile.vue?vue&type=template&id=2b9d0daa&scoped=true&ts=true&lang=pug"
import script from "./SupplierFile.vue?vue&type=script&lang=ts"
export * from "./SupplierFile.vue?vue&type=script&lang=ts"

import "./SupplierFile.vue?vue&type=style&index=0&id=2b9d0daa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9d0daa"]])

export default __exports__